import React, { Component } from 'react';

import "./Stories.scss"

import Story from "./components/Story/Story"

import json from "../../api/data.json"

class Stories extends Component {
  constructor() {
    super();
    this.state = {
    }
  }
  getItems() {
    return json.stories.list.map((story, index) =>
      <Story key={index.toString()} story={story} />
    );
  }
  render() {
    return (
      <section className="section section-stories">
      <div className="padding">
      <div className="pinGridWrapper">
      <div className="pinGrid">
        {this.getItems()}
        </div>
        </div>
        </div>
      </section>
    );
  }
}

export default Stories;



// WEBPACK FOOTER //
// ./src/components/Stories/Stories.js